export const geometergeschaeftSearchModeName = 'searchMode';
export type GeometergeschaeftSearchMode = 'searchStandard';
